import type { DocumentCategory } from '@immo/api-contract';
import type { EnumTranslation } from '../types';

// The ~40 document types shown in tags + picker options, and (IMM-1040.3) the
// WhatsApp confirmation preview — lifted here so both surfaces read one map.
export const DOCUMENT_CATEGORY_LABELS = {
  // Vermarktung
  EXPOSE: 'Exposé',
  FLOOR_PLAN: 'Grundriss',
  SITE_PLAN: 'Lageplan',
  LIVING_AREA_CALCULATION: 'Wohn-/Nutzflächenberechnung',
  // Energie & Technik
  ENERGY_CERTIFICATE: 'Energieausweis',
  MAINTENANCE_RECORD: 'Wartungsnachweis',
  TECHNICAL_REPORT: 'Technisches Gutachten / Sachverständigengutachten',
  // Eigentum & Grundbuch
  LAND_REGISTER_EXTRACT: 'Grundbuchauszug',
  CADASTRAL_MAP: 'Flurkarte / Katasterauszug',
  BUILDING_ENCUMBRANCE: 'Baulastenauskunft',
  CONTAMINATED_SITES_REGISTER_EXTRACT: 'Altlastenauskunft',
  DECLARATION_OF_DIVISION: 'Teilungserklärung',
  PARTITION_PLAN: 'Aufteilungsplan',
  CERTIFICATE_OF_COMPLETENESS: 'Abgeschlossenheitsbescheinigung',
  HERITABLE_BUILDING_RIGHT: 'Erbbaurechtsvertrag',
  // Bau & Genehmigung
  BUILDING_PERMIT: 'Baugenehmigung',
  BUILDING_DESCRIPTION: 'Baubeschreibung',
  BUILDING_FILE: 'Bauakte / Baupläne',
  HERITAGE_PROTECTION: 'Denkmalschutz-Bescheinigung',
  RENOVATION_RECORD: 'Sanierungs-/Modernisierungsnachweis',
  // Verwaltung (WEG & Miete)
  OWNERS_MEETING_MINUTES: 'Protokoll Eigentümerversammlung',
  RESOLUTION_COLLECTION: 'Beschlusssammlung',
  ECONOMIC_PLAN: 'Wirtschaftsplan',
  HOA_STATEMENT: 'Hausgeldabrechnung',
  PROPERTY_MANAGEMENT_CONTRACT: 'Verwaltervertrag',
  RENTAL_CONTRACT: 'Mietvertrag',
  UTILITY_STATEMENT: 'Nebenkostenabrechnung',
  TENANT_LIST: 'Mieterliste / Mietaufstellung',
  RESIDENCE_CONFIRMATION: 'Wohnungsgeberbestätigung',
  HOUSE_RULES: 'Hausordnung',
  // Verträge & Transaktion
  BROKER_CONTRACT: 'Maklervertrag',
  RESERVATION_AGREEMENT: 'Reservierungsvereinbarung',
  PURCHASE_CONTRACT: 'Kaufvertrag / Notarvertrag',
  HANDOVER_PROTOCOL: 'Übergabeprotokoll',
  POWER_OF_ATTORNEY: 'Vollmacht',
  // Finanzen & Steuern
  PROPERTY_TAX_ASSESSMENT: 'Grundsteuerbescheid',
  VALUATION_REPORT: 'Wertgutachten / Verkehrswertgutachten',
  ACQUISITION_BRIEFING: 'Akquisebriefing',
  VALUATION: 'Bewertung',
  FINANCING_CONFIRMATION: 'Finanzierungsbestätigung',
  // Person & Legitimation
  SELF_DISCLOSURE: 'Selbstauskunft',
  CREDIT_REPORT: 'Bonitätsnachweis / SCHUFA',
  IDENTITY_DOCUMENT: 'Legitimation / Ausweis (GwG)',
  INCOME_PROOF: 'Einkommensnachweis',
  // Versicherung
  INSURANCE_CERTIFICATE: 'Versicherungsnachweis',
  // Sonstiges
  MISC: 'Sonstiges',
  UNCATEGORIZED: 'Unkategorisiert',
} as const satisfies EnumTranslation<DocumentCategory>;
